
import headerLogoSvg from '../Assets/HeaderLogoSvg.svg'


export const HeaderComponent = () => {
  return (
    <div >
      <div className="d-flex gap-3 align-items-center py-3 px-5 border-bottom" >
        <img src={headerLogoSvg} alt="icon" style={{width:'1rem', height:'1rem'}}/>
        <div style={{ color: 'black', fontSize: '1.125rem', fontWeight: '700',letterSpacing:'-0.015rem',lineHeight:'1.25' }}>Sistema de Cohorts</div>
      </div>
    </div>
  )
}